import OrderHistoryProductCard from './OrderHistoryProductCard';

export default OrderHistoryProductCard;
